module.exports = __webpack_public_path__ + "img/logo-blanc-rvb-ubiflow-2026.71978ef8.svg";